import React from "react";
import styled from "styled-components";
import { Link, useLocation } from "react-router-dom";
import { Row, Col, Image } from "antd";
import LogoImage from "../../assets/logo/logo-mealmate-removebg-preview.png";

const FooterComponent = () => {
  const location = useLocation();

  return (
    <FooterContainer>
      <FooterContent>
        <Row gutter={[16, 16]} justify="space-between" align="middle">
          <Col xs={24} sm={24} md={6}>
            <LogoSection>
              <LogoWrapper>
                <StyledImage
                  src={LogoImage}
                  alt="Mealmate Logo"
                  preview={false}
                  width={75}
                />
                <LogoText>
                  <span>Meal</span>
                  <span>mate</span>
                </LogoText>
              </LogoWrapper>
            </LogoSection>
          </Col>

          <Col xs={24} sm={24} md={12}>
            <NavSection>
              <NavLinks>
                <NavLink
                  to="/"
                  className={location.pathname === "/" ? "active" : ""}
                >
                  TRANG CHỦ
                </NavLink>
                <NavLink
                  to="/recipes"
                  className={location.pathname === "/recipes" ? "active" : ""}
                >
                  CÔNG THỨC
                </NavLink>
                <NavLink
                  to="/menus"
                  className={location.pathname === "/menus" ? "active" : ""}
                >
                  THỰC ĐƠN
                </NavLink>
                <NavLink
                  to="/blogs"
                  className={location.pathname === "/blogs" ? "active" : ""}
                >
                  BÀI VIẾT
                </NavLink>
              </NavLinks>
            </NavSection>
          </Col>

          <Col xs={24} sm={24} md={6}>
            <SocialSection>
              <SocialLinks>
                <SocialLink
                  href="https://www.facebook.com/people/MealMate/61576241234036/"
                  aria-label="Facebook"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path
                      d="M22 12C22 6.477 17.523 2 12 2S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.877v-6.987h-2.54v-2.89h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.242 0-1.632.771-1.632 1.562v1.875h2.773l-.443 2.89h-2.33v6.987C18.343 21.128 22 16.991 22 12z"
                      fill="currentColor"
                    />
                  </svg>
                </SocialLink>
                <SocialLink href="/twitter" aria-label="Twitter">
                  <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path
                      d="M22.46 6c-.793.352-1.645.59-2.54.698a4.48 4.48 0 0 0 1.963-2.475 8.94 8.94 0 0 1-2.828 1.082A4.48 4.48 0 0 0 16.11 4c-2.485 0-4.5 2.014-4.5 4.5 0 .353.04.697.116 1.027C7.728 9.37 4.1 7.6 1.67 4.905c-.388.666-.61 1.44-.61 2.263 0 1.563.796 2.942 2.006 3.75a4.48 4.48 0 0 1-2.037-.563v.057c0 2.183 1.553 4.005 3.617 4.422-.378.104-.776.16-1.187.16-.29 0-.57-.028-.844-.08.57 1.78 2.223 3.078 4.183 3.113A8.98 8.98 0 0 1 2 19.54 12.68 12.68 0 0 0 8.29 21.5c7.547 0 11.675-6.155 11.675-11.49 0-.175-.004-.35-.012-.522A8.18 8.18 0 0 0 22.46 6z"
                      fill="currentColor"
                    />
                  </svg>
                </SocialLink>
                <SocialLink href="/youtube" aria-label="YouTube">
                  <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path
                      d="M21.8 8.001a2.75 2.75 0 0 0-1.936-1.946C18.14 6 12 6 12 6s-6.14 0-7.864.055A2.75 2.75 0 0 0 2.2 8.001 28.6 28.6 0 0 0 2 12a28.6 28.6 0 0 0 .2 3.999 2.75 2.75 0 0 0 1.936 1.946C5.86 18 12 18 12 18s6.14 0 7.864-.055A2.75 2.75 0 0 0 21.8 15.999 28.6 28.6 0 0 0 22 12a28.6 28.6 0 0 0-.2-3.999zM10 15V9l6 3-6 3z"
                      fill="currentColor"
                    />
                  </svg>
                </SocialLink>
                <SocialLink href="/instagram" aria-label="Instagram">
                  <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path
                      d="M7 2C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5H7zm10 2c1.654 0 3 1.346 3 3v10c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3h10zm-5 3a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm6.5-.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
                      fill="currentColor"
                    />
                  </svg>
                </SocialLink>
              </SocialLinks>
              <div style={{ marginTop: "16px", textAlign: "center" }}>
                <p style={{ margin: 0, fontSize: "14px", color: "#555" }}>
                  📞 0367898377
                </p>
                <p style={{ margin: 0, fontSize: "14px", color: "#555" }}>
                  ✉️ minhtrang052003@gmail.com
                </p>
              </div>
            </SocialSection>
          </Col>
        </Row>
      </FooterContent>
      <Copyright>COPYRIGHT: © 2025 MEAL MATE.</Copyright>
    </FooterContainer>
  );
};

const FooterContainer = styled.footer`
  width: 100%;
  background: #fff;
  padding: 2rem 3rem 0 3rem;
  border-radius: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin: 2rem 0;
`;
const FooterContent = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding-bottom: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 2rem;
    padding: 0 1rem;
  }
`;

const LogoSection = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  min-width: 140px;
  position: relative;

  @media (max-width: 768px) {
    flex-direction: row;
    justify-content: center;
  }
`;

const StyledImage = styled(Image)`
  img {
    object-fit: contain;
  }

  @media (max-width: 768px) {
    width: 60px;
  }
`;

const LogoText = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.1;
  position: relative;
  z-index: 1;

  span {
    font-weight: 600;
    font-size: 1.2rem;

    &:first-child {
      color: #ff9f1c;
    }

    &:last-child {
      color: #011936;
    }
  }

  @media (max-width: 768px) {
    text-align: center;
    font-size: 1rem;
  }
`;

const NavSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const NavLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 3rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }
`;

const NavLink = styled(Link)`
  position: relative;
  text-decoration: none;
  color: #444;
  font-weight: 600;
  font-size: 1rem;
  text-transform: uppercase;

  &:after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -6px;
    width: 0%;
    height: 2px;
    background-color: #ff4c4c;
    transition: width 0.3s ease-in-out;
  }

  &.active {
    color: #000;
    &:after {
      width: 100%;
    }
  }

  &:hover {
    color: #000;
  }
`;

const SocialSection = styled.div`
  display: flex;
  flex-direction: column; /* ✅ icon ở trên, liên hệ ở dưới */
  align-items: center;
  width: 100%;

  @media (max-width: 768px) {
    justify-content: center;
    margin-top: 1rem;
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1.2rem;
  align-items: center;
  justify-content: center; /* ✅ căn giữa icon */
  margin-bottom: 1rem; /* ✅ tạo khoảng cách với phần liên hệ */
  flex-wrap: wrap;
`;

const SocialLink = styled.a`
  color: #333;
  display: flex;
  align-items: center;
  transition: color 0.3s;

  &:hover {
    color: #ff9f1c;
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;

const Copyright = styled.div`
  text-align: center;
  color: #666;
  font-size: 0.85rem;
  padding-top: 1rem;
  border-top: 1px solid #eee;
  margin-top: 1rem;
`;

export default FooterComponent;
